import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import messages from '../../locale/messages';
import validateStep3 from './validateStep3';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import FormControl from 'react-bootstrap/lib/FormControl';
import Button from 'react-bootstrap/lib/Button';

import FooterButton from './FooterButton';
import SidePanel from './SidePanel';
import InputFieldComponent from '../Common/FormField/InputFieldComponent';

import updateStep3 from './updateStep3';
import { normalizePrice } from '../../helpers/normalizePrice';
import { DecrementIcon } from '../Common/Assets/SvgComponent/commonSvgIcon';

import toolTipIcon from '/public/SiteIcons/listCommonToolTip.svg';

import s from './ListPlaceStep1.css';
import bt from '../../components/commonStyle.css';

class Discount extends Component {

  static propTypes = {
    previousPage: PropTypes.any,
    nextPage: PropTypes.any
  };

  constructor(props) {
    super(props);
    this.state = {
      isDisabled: true,
      customDiscounts: [],
    };
  }

  UNSAFE_componentWillMount() {
    const { valid, listingFields, customDiscounts } = this.props;
    this.setState({ isDisabled: valid ? false : true });

    // Load existing custom discounts
    if (customDiscounts) {
      try {
        const parsedDiscounts = JSON.parse(customDiscounts);
        this.setState({ customDiscounts: parsedDiscounts });
      } catch (e) {
        console.log("Error parsing customDiscounts:", e);
      }
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { valid, listingFields, customDiscounts } = nextProps;
    this.updateFormValidation(valid);

    // Load existing custom discounts when props change
    if (customDiscounts && customDiscounts !== this.props.customDiscounts) {
      try {
        const parsedDiscounts = JSON.parse(customDiscounts);
        this.setState({ customDiscounts: parsedDiscounts }, () => {
          this.updateFormValidation(valid);
        });
      } catch (e) {
        console.log("Error parsing customDiscounts:", e);
      }
    }
  }

  validateCustomDiscounts = () => {
    const { customDiscounts } = this.state;
    return customDiscounts.every((discount) => {
      // If any field is filled, all fields must be filled
      const hasAnyField =
        discount.periodType ||
        discount.periodValue ||
        discount.discountPercentage;
      const hasAllFields =
        discount.periodType &&
        discount.periodValue &&
        discount.discountPercentage;

      return !hasAnyField || hasAllFields;
    });
  };

  updateFormValidation = (reduxFormValid) => {
    const customDiscountsValid = this.validateCustomDiscounts();
    this.setState({
      isDisabled: !(reduxFormValid && customDiscountsValid),
    });
  };

  addCustomDiscount = () => {
    const { customDiscounts } = this.state;
    const updatedDiscounts = [
      ...customDiscounts,
      { periodType: "", periodValue: "", discountPercentage: "" },
    ];
    this.setState(
      {
        customDiscounts: updatedDiscounts,
      },
      () => {
        this.updateFormValidation(this.props.valid);
        // Update Redux Form field
        this.props.change(
          "customDiscounts",
          JSON.stringify(updatedDiscounts)
        );
      }
    );
  };

  removeCustomDiscount = (index) => {
    const { customDiscounts } = this.state;
    const updatedDiscounts = customDiscounts.filter((_, i) => i !== index);
    this.setState({ customDiscounts: updatedDiscounts }, () => {
      this.updateFormValidation(this.props.valid);
      // Update Redux Form field
      this.props.change(
        "customDiscounts",
        JSON.stringify(updatedDiscounts)
      );
    });
  };

  updateCustomDiscount = (index, field, value) => {
    const { customDiscounts } = this.state;
    const updatedDiscounts = [...customDiscounts];
    updatedDiscounts[index] = {
      ...updatedDiscounts[index],
      [field]: value,
    };
    this.setState({ customDiscounts: updatedDiscounts }, () => {
      this.updateFormValidation(this.props.valid);
      // Update Redux Form field
      this.props.change(
        "customDiscounts",
        JSON.stringify(updatedDiscounts)
      );
    });
  };

  updateCustomDiscountBoth = (index, periodType, periodValue) => {
    const { customDiscounts } = this.state;
    const updatedDiscounts = [...customDiscounts];
    updatedDiscounts[index] = {
      ...updatedDiscounts[index],
      periodType,
      periodValue,
    };
    this.setState({ customDiscounts: updatedDiscounts }, () => {
      this.updateFormValidation(this.props.valid);
      // Update Redux Form field
      this.props.change(
        "customDiscounts",
        JSON.stringify(updatedDiscounts)
      );
    });
  };

  renderCustomDiscounts = () => {
    const { customDiscounts } = this.state;
    const { formatMessage } = this.props.intl;

    const periodOptions = [
      { value: "nights:2", label: formatMessage(messages.nights2) },
      { value: "nights:3", label: formatMessage(messages.nights3) },
      { value: "nights:4", label: formatMessage(messages.nights4) },
      { value: "nights:5", label: formatMessage(messages.nights5) },
      { value: "nights:6", label: formatMessage(messages.nights6) },
      { value: "weeks:1", label: formatMessage(messages.week1) },
      { value: "weeks:2", label: formatMessage(messages.weeks2) },
      { value: "months:1", label: formatMessage(messages.month1) },
    ];

    // Get already selected durations
    const getSelectedDurations = () => {
      return customDiscounts
        .filter(
          (discount) => discount.periodType && discount.periodValue
        )
        .map(
          (discount) =>
            `${discount.periodType}:${discount.periodValue}`
        );
    };

    return (
      <div className={s.spaceTop4}>
        <FormGroup className={cx(s.formGroup, s.space4)}>
          <ControlLabel className={cx(s.landingLabel)}>
            <FormattedMessage {...messages.customDiscounts} />
          </ControlLabel>
          <div className={s.tipCommonCss}>
            <img src={toolTipIcon} />
            <span className={cx(s.commonTipCsss)}>
              <FormattedMessage
                {...messages.customDiscountsTip}
              />
            </span>
          </div>
        </FormGroup>

        {customDiscounts.map((discount, index) => {
          const selectedDurations = getSelectedDurations();
          const currentSelection =
            discount.periodType && discount.periodValue
              ? `${discount.periodType}:${discount.periodValue}`
              : "";

          return (
            <div
              key={index}
              className={cx(s.formGroup, s.space4)}
              style={{
                display: "flex",
                gap: "10px",
                alignItems: "flex-end",
              }}
            >
              <div style={{ flex: 2 }}>
                <ControlLabel className={cx(s.landingLabel)}>
                  <FormattedMessage
                    {...messages.discountPeriod}
                  />
                </ControlLabel>
                <FormControl
                  componentClass="select"
                  value={
                    discount.periodType &&
                    discount.periodValue
                      ? `${discount.periodType}:${discount.periodValue}`
                      : ""
                  }
                  onChange={(e) => {
                    if (e.target.value === "") {
                      this.updateCustomDiscountBoth(
                        index,
                        "",
                        ""
                      );
                    } else {
                      const [type, value] =
                        e.target.value.split(":");

                      this.updateCustomDiscountBoth(
                        index,
                        type,
                        parseInt(value)
                      );
                    }
                  }}
                  className={cx(
                    bt.commonControlSelect,
                    "commonControlSelectRtl"
                  )}
                >
                  <option value="">
                    {formatMessage(messages.selectPeriod)}
                  </option>
                  {periodOptions.map((option) => {
                    const isDisabled =
                      selectedDurations.includes(
                        option.value
                      ) &&
                      option.value !== currentSelection;
                    return (
                      <option
                        key={option.value}
                        value={option.value}
                        disabled={isDisabled}
                      >
                        {option.label}
                      </option>
                    );
                  })}
                </FormControl>
              </div>
              <div style={{ flex: 1 }}>
                <ControlLabel className={cx(s.landingLabel)}>
                  <FormattedMessage
                    {...messages.discountPercentage}
                  />
                </ControlLabel>
                <input
                  type="text"
                  value={discount.discountPercentage}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "") {
                      this.updateCustomDiscount(
                        index,
                        "discountPercentage",
                        ""
                      );
                    } else {
                      const numValue = parseFloat(value);
                      if (
                        !isNaN(numValue) &&
                        numValue >= 0 &&
                        numValue <= 99
                      ) {
                        this.updateCustomDiscount(
                          index,
                          "discountPercentage",
                          numValue
                        );
                      }
                    }
                  }}
                  className={bt.commonControlInput}
                  placeholder="0"
                  min="0"
                  max="99"
                />
              </div>
              <div style={{ flex: 0 }}>
                <Button
                  className={cx(s.btnWidth)}
                  onClick={() =>
                    this.removeCustomDiscount(index)
                  }
                  type="button"
                  style={{
                    height: "58px",
                    backgroundColor:
                      "var(--error-color, #dc3545)",
                    borderColor:
                      "var(--error-color, #dc3545)",
                    minWidth: "58px",
                    padding: "0",
                    color: "#fff",
                  }}
                >
                  <DecrementIcon />
                </Button>
              </div>
            </div>
          );
        })}

        <FormGroup className={cx(s.formGroup, s.space4)}>
          <Button
            className={cx(bt.btnPrimaryBorder, s.btnWidth)}
            onClick={this.addCustomDiscount}
            type="button"
          >
            + <FormattedMessage {...messages.addDiscountRule} />
          </Button>
        </FormGroup>
      </div>
    );
  };

  render() {
    const { handleSubmit, nextPage, previousPage, formPage, step } = this.props;
    const { isDisabled } = this.state;
    const { formatMessage } = this.props.intl;
    return (
      <div className={s.grid}>
        <SidePanel
          title={formatMessage(messages.stepThreeCommonHeading)}
          landingContent={formatMessage(messages.discount)}
        />
        <form onSubmit={handleSubmit}>
          <div className={cx(s.landingMainContent, 'disCountAddon')}>
            {/* <FormGroup className={s.formGroup}>
              <ControlLabel className={cx(s.landingLabel)}>
                <FormattedMessage {...messages.discountWeekly} />
              </ControlLabel>
              <Field
                name="weeklyDiscount"
                type="text"
                component={InputFieldComponent}
                placeholder={formatMessage(messages.discountLabel)}
                inputClass={bt.commonControlInput}
                prefixLabel={'%'}
                isAddon={true}
                normalize={normalizePrice}
              />
            </FormGroup>
            <FormGroup className={cx(s.formGroup, s.spaceTop4)}>
              <ControlLabel className={cx(s.landingLabel)}>
                <FormattedMessage {...messages.discountMonthly} />
              </ControlLabel>
              <Field
                name="monthlyDiscount"
                type="text"
                component={InputFieldComponent}
                placeholder={formatMessage(messages.discountLabel)}
                inputClass={bt.commonControlInput}
                prefixLabel={'%'}
                isAddon={true}
                normalize={normalizePrice}
              />
            </FormGroup>
            <div className={s.tipCommonCss}>
              <img src={toolTipIcon} />
              <span className={cx(s.commonTipCsss)}><FormattedMessage {...messages.discountTip} /></span>
            </div> */}

            {/* Custom Discounts Section */}
            {this.renderCustomDiscounts()}

            {/* Hidden field to store customDiscounts in Redux Form */}
            <Field
              name="customDiscounts"
              component="input"
              type="hidden"
              value={JSON.stringify(this.state.customDiscounts)}
            />
          </div>
          <FooterButton
            nextPage={nextPage}
            previousPage={previousPage}
            nextPagePath={"min-max-nights"}
            previousPagePath={"pricing"}
            formPage={formPage}
            step={step}
            isDisabled={isDisabled}
          />
        </form>
      </div>
    );
  }
}

Discount = reduxForm({
  form: 'ListPlaceStep3', // a unique name for this form
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate: validateStep3,
  onSubmit: updateStep3
})(Discount);

// Form selector to get customDiscounts value from ListPlaceStep3 form
const selectorStep3 = formValueSelector("ListPlaceStep3");

const mapState = (state) => ({
  listingFields: state.listingFields.data,
  customDiscounts: selectorStep3(state, "customDiscounts"),
});

const mapDispatch = {};

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(Discount)));
